import React, { useState, useContext } from "react";
import RegionContext from "../../../../RegionContext";
import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./ContactUs.css";
import { FRBanner } from "../../../Banner/Banner";
import { cdn } from "../../../../consts/cdn";
import { api } from "../../../../consts/api";

// Images
const BannerDesktop = cdn.images + "ContactUs/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "ContactUs/Banner-Mobile.jpg";

function ContactUs() {
  const region = useContext(RegionContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setNumber] = useState("");
  const [facility, setFacility] = useState("");
  const [facilityAddress, setFacilityAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [comments, setComment] = useState("");
  const [check, setCheck] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [error, setError] = useState(false);
  const [validate, setValidate] = useState(false);


  // Intercept native validation and inject French messages
  const handleInvalid = (e) => {
    const { validity, type } = e.target;
    if (validity.valueMissing) {
      e.target.setCustomValidity("Veuillez remplir ce formulaire.");
    } else if (validity.typeMismatch && type === "email") {
      e.target.setCustomValidity(
        "Veuillez saisir une adresse électronique valide."
      );
    } else {
      e.target.setCustomValidity("Valeur non valide.");
    }
  };


  // Clear any custom message on input
  const handleInput = (e) => {
    e.target.setCustomValidity("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidate(true);
    setError(false);

    // Perform HTML5 constraint validation before submission
    const form = event.target;
    if (!form.checkValidity()) {
      form.reportValidity();
      setValidate(false);
      return;
    }

    const url = api + "/contactus";
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        phoneNumber,
        facility,
        facilityAddress,
        city,
        country,
        comments,
        region, // Add region attribute
      }),
    };

    fetch(url, requestOptions)
      .then((response) => {
        setValidate(false);
        setSubmit(true);
        // Reset form
        setName("");
        setEmail("");
        setNumber("");
        setFacility("");
        setFacilityAddress("");
        setCity("");
        setCountry("");
        setComment("");
        console.log("Form submit success: ", response);
      })
      .catch((error) => {
        setValidate(false);
        setSubmit(false);
        setError(true);
        console.log("Form submit error: ", error);
      });
  };

  return (
    <>
      <div className="contact-us">
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="CONTACTEZ-NOUS"
          color="#365B7E"
        />

        <div className="content">
          <div className="contact-us__form-container">
            {submit && !error ? (
              <div>
                <div className="success-animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
                <p
                  style={{
                    color: "#1b3b5a",
                    fontSize: "20px",
                    marginTop: "40px",
                    marginBottom: "100px",
                    textAlign: "center",
                  }}
                >
                  Merci ! Votre soumission a été reçue.
                </p>
              </div>
            ) : (
              // Removed noValidate to re-enable native validation
              <form onSubmit={handleSubmit}>
                <p className="paragraph contact-us__paragraph">
                  Contactez-nous pour plus d'informations sur le vNOTES et sur la disponibilité des formations dans votre région.
                </p>

                {/* Nom */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Nom <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="text"
                    value={name}
                    name="name"
                    onChange={(e) => setName(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Email */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Adresse électronique <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="email"
                    value={email}
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Téléphone */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">Numéro de téléphone</label>
                  <input
                    className="contact-us__input"
                    type="tel"
                    value={phoneNumber}
                    name="phoneNumber"
                    onChange={(e) => setNumber(e.target.value)}
                  />
                </div>

                {/* Établissement */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Établissement <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="text"
                    value={facility}
                    name="facility"
                    onChange={(e) => setFacility(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Adresse de l'établissement */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Adresse de l'établissement <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="text"
                    value={facilityAddress}
                    name="address"
                    onChange={(e) => setFacilityAddress(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Ville */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Ville <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="text"
                    value={city}
                    name="city"
                    onChange={(e) => setCity(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Pays */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">
                    Pays <span className="contact-us__span-required">(obligatoire)</span>
                  </label>
                  <input
                    className="contact-us__input"
                    type="text"
                    value={country}
                    name="country"
                    onChange={(e) => setCountry(e.target.value)}
                    required
                    onInvalid={handleInvalid}
                    onInput={handleInput}
                  />
                </div>

                {/* Commentaires */}
                <div className="contact-us__input-container">
                  <label className="contact-us__label">Commentaires</label>
                  <textarea
                    className="contact-us__textarea"
                    value={comments}
                    name="comments"
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>

                <input
                  type="checkbox"
                  style={{ display: "none", visibility: "hidden" }}
                  name="checkbox_add"
                  id="checkbox_add"
                  onClick={() => setCheck(!check)}
                />

                {error && (
                  <p style={{ color: "red", textAlign: "center", marginTop: "40px" }}>
                    Une erreur est survenue. Veuillez réessayer plus tard.
                  </p>
                )}

                {validate ? (
                  <div className="contact-us__button">
                    <div className="validate"></div>
                  </div>
                ) : (
                  <div className="contact-us__button">
                    <button className="btn" type="submit">
                      Soumettre
                    </button>
                  </div>
                )}
              </form>
            )}

            <p className="paragraph contact-us__paragraph--disclaimer">
              La divulgation de ces données se fait par votre consentement. En fournissant vos données personnelles, vous autorisez Applied Medical à les utiliser et à donner suite à votre demande d'informations complémentaires à l'adresse électronique et/ou au numéro de téléphone que vous avez mentionné dans ce formulaire. Applied Medical ne transférera pas vos données personnelles à des tiers à moins que la loi ne l'exige et prendra toutes les mesures appropriées pour les protéger contre tout accès non autorisé. Nous conserverons vos données personnelles dans notre base de données CRM. Vous pouvez vous rétracter à tout moment en contactant{' '}
              <a className="contact-us__anchor" href="mailto:DPO-Europe@appliedmedical.com">
                DPO-Europe@appliedmedical.com
              </a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
